import React from 'react';
import styled from 'styled-components';
import { PlatformAdminRow } from '../../../../../models/entities/platform/platformSuperAdmin';
import { ColumnType } from '../../../../shared/Grid/types/Column';

type ColumnHandlers = {
    onRevoke: (email: string) => void;
    localization: any;
};

const platformSuperAdminsGridColumns = ({ onRevoke, localization }: ColumnHandlers): Array<ColumnType<PlatformAdminRow>> => [
    {
        field: 'email',
        width: '240px',
        minWidth: '200px',
        sortable: true,
        textAlign: 'left'
    },
    {
        field: 'source',
        width: '100%',
        minWidth: '160px',
        sortable: true,
        textAlign: 'center',
        renderer: (cellValue: PlatformAdminRow['source']) => (
            <SourceBadge $bootstrap={cellValue === 'bootstrap'}>
                {cellValue === 'bootstrap' ? localization.grid.source_bootstrap : localization.grid.source_database}
            </SourceBadge>
        )
    },
    {
        field: 'id',
        title: 'Actions',
        width: '140px',
        sortable: false,
        textAlign: 'center',
        bindedFields: ['source', 'email'],
        renderer: (_id: string, bindedData?: Array<any> | null) => {
            const source = bindedData?.[0] as PlatformAdminRow['source'];
            const email = bindedData?.[1] as string;
            if (source === 'bootstrap') {
                return <MutedText>{localization.grid.revoke_disabled}</MutedText>;
            }
            return (
                <RevokeButton type="button" onClick={() => onRevoke(email)}>
                    {localization.grid.revoke_btn}
                </RevokeButton>
            );
        }
    }
];

const SourceBadge = styled.span<{ $bootstrap: boolean }>`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    color: ${(props) => (props.$bootstrap ? '#5c4b00' : '#0b3d5c')};
    background: ${(props) => (props.$bootstrap ? '#fff3cd' : '#e7f3ff')};
`;

const RevokeButton = styled.button`
    border: none;
    background: transparent;
    color: ${(props) => props.theme.colors.link};
    cursor: pointer;
    font-weight: 600;

    &:hover {
        text-decoration: underline;
    }
`;

const MutedText = styled.span`
    color: #999;
    font-size: 12px;
`;

export default platformSuperAdminsGridColumns;
